import { Injectable } from '@nestjs/common';
import { GradesDTO } from '../dto/grades.dto';
import { Grades} from '../grades.entity';

@Injectable()
export class GradesAdapter {
  /**
   * 
   * @param gradesDto 
   * @param isUpdate 
   * @returns 
   */
  public convertDtoToEntity(  gradesDto: GradesDTO,  isUpdate: boolean = false ): Grades {
    const grades = new Grades();
    grades.gradeId=gradesDto.gradeId;
    grades.gradeName=gradesDto.gradeName;
    grades.gradeMinCount=gradesDto.gradeMinCount;
    grades.gradeMaxCount=gradesDto.gradeMaxCount;
    grades.packCount = gradesDto.packCount
    // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    grades.isActive=gradesDto.isActive==undefined?true:gradesDto.isActive;
    if (isUpdate) {
        grades.updatedUser = gradesDto.updatedUser;
    } else {
        grades.isActive = true;
        grades.createdUser = gradesDto.createdUser;
    }
   return grades;
  }
  public convertEntityToDto(gradesObject: Grades): GradesDTO {
    const gradesDto= new GradesDTO;
    gradesDto.gradeId=gradesObject.gradeId;
    gradesDto.gradeName=gradesObject.gradeName;
    gradesDto.gradeMinCount=gradesObject.gradeMinCount;
    gradesDto.gradeMaxCount=gradesObject.gradeMaxCount;
    gradesDto.isActive = gradesObject.isActive;
    gradesDto.createdAt = gradesObject.createdAt;
    gradesDto.updatedAt = gradesObject.updatedAt;
    gradesDto.createdUser = gradesObject.createdUser;
    gradesDto.updatedUser = gradesObject.updatedUser;
    gradesDto.versionFlag = gradesObject.versionFlag;
    gradesDto.packCount = gradesObject.packCount
    return gradesDto;
  }
}
